import { ReactNode, useContext, useEffect } from 'react';
import { PrimeReactContext } from 'primereact/api';
import { useFullscreenDialogParent } from '../general/use-fullscreen-dialog-parent';

/** Default parent for dropdowns, confirmations and other PrimeReact overlays. */
export function FullscreenOverlayProvider({ children }: { children: ReactNode }) {
    const { setAppendTo } = useContext(PrimeReactContext);
    const parent = useFullscreenDialogParent();
    useEffect(() => { setAppendTo?.(parent ?? document.body); }, [parent, setAppendTo]);
    return <>{children}</>;
}
